import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["deletionCheckbox", "deletionMessage", "fieldset"]

  removeFieldset(e) {
    e.preventDefault()
    e.target.closest("fieldset").remove()
    this.dispatch("changed")
  }

  markForDeletion() {
    this.deletionCheckboxTarget.checked = !this.deletionCheckboxTarget.checked
    this.deletionMessageTarget.classList.toggle("hidden")
    this.fieldsetTarget.classList.toggle("border-3")
    this.fieldsetTarget.classList.toggle("border-custom-red/25")
    this.dispatch("changed")
  }
}
